import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';
import { useStyles } from '@wix/tpa-settings/dist/src/hooks';
import { instagramStyleParams } from '../../../../../settings';
import IconAndText from './IconAndText';
import { DISPLAY_ON_HOVER } from '../../../../../constants/settingsConstants';

import { st, classes } from './ProGalleryHoverItem.st.css';

const ProGalleryHoverItem = ({
  item,
  galleryHoverTextColor,
  galleryHoverFillColor,
  displayOnHover,
  isBusinessApp,
  isMobile,
  width,
  isHover,
  overlayEffect,
}) => {
  const styles = useStyles();
  const id = item.id;
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    const captionDiv = document.getElementById('caption' + id);
    const rootHover = document.getElementById('rootHover' + id);

    if (captionDiv) {
      if (captionDiv.clientHeight > rootHover.clientHeight) {
        captionDiv.innerText = captionDiv.innerText.replace(
          /\W*\s(\S)*$/,
          '...'
        );
      }
    }
  }, [id]);

  galleryHoverTextColor = galleryHoverTextColor
    ? galleryHoverTextColor.value
    : styles.get(instagramStyleParams.galleryHoverTextColor).value;

  galleryHoverFillColor = galleryHoverFillColor
    ? galleryHoverFillColor.value
    : styles.get(instagramStyleParams.galleryHoverFillColor).value;

  const isMedium = width >= 108 && width < 192;
  const caption =
    item.caption && item.caption.text
      ? item.caption.text
      : typeof item.caption === 'object'
      ? ''
      : item.caption;

  if (isMobile) {
    return null;
  }

  return (
    <div
      id={'rootHover' + item.id}
      className={st(classes.root, { isHover, overlayEffect })}
      style={{
        backgroundColor: galleryHoverFillColor,
      }}
    >
      {isBusinessApp && displayOnHover === DISPLAY_ON_HOVER.COUNTERS ? (
        <div className={isMedium ? '' : st(classes.WarpContent)}>
          <IconAndText
            isLikeIcon={true}
            text={item.like_count || '0'}
            galleryHoverTextColor={galleryHoverTextColor}
            isMedium={isMedium}
          />
          <IconAndText
            isLikeIcon={false}
            text={item.comments_count || '0'}
            galleryHoverTextColor={galleryHoverTextColor}
            isMedium={isMedium}
          />
        </div>
      ) : (
        <div
          id={'caption' + item.id}
          className={st(classes.caption, { isMedium })}
          style={{ color: galleryHoverTextColor }}
        >
          {caption || ''}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  galleryHoverTextColor: state.settingsReducer.galleryHoverTextColor,
  galleryHoverFillColor: state.settingsReducer.galleryHoverFillColor,
  isBusinessApp: state.appReducer.isBusinessApp,
  displayOnHover: state.settingsReducer.displayOnHover,
  isMobile: state.appReducer.isMobile,
  overlayEffect: state.settingsReducer.overlayEffect,
});

export default connect(
  mapStateToProps,
  null
)(withResizeDetector(ProGalleryHoverItem));
